import { cn } from "@gettactic/helpers";
import SetupAnimatedBackground from "@webV2/setup/background/SetupAnimatedBackground";
import React from "react";
import { useAskTessa } from "@v2/components/ai/AskTessaProvider";
import { useCloseAnimationTimeout } from "@gettactic/helpers/src/hooks/useCloseAnimationTimeout";

export const TessaFullScreenBackground: React.FC = () => {
  const askTessa = useAskTessa();
  const isPopup = askTessa?.isPopup?.state || false;
  const isOpen = askTessa?.tessaDisclosure.isOpen || false;
  const isSidebarOpen = askTessa?.sidebarDisclosure.isOpen ?? true;
  const isToolFullScreen = askTessa?.fullPageToolDisclosure.isOpen ?? false;

  const { isVisible } = useCloseAnimationTimeout(!isSidebarOpen);

  return (
    <div
      className={cn(
        isPopup
          ? "opacity-0 transition-all"
          : "absolute inset-0 backdrop-blur-sm",
        isSidebarOpen || isToolFullScreen ? "bg-white" : undefined
      )}
    >
      {!isSidebarOpen && !isToolFullScreen && (
        <SetupAnimatedBackground
          className={cn(
            "absolute",
            "opacity-60 backdrop-blur-sm"
            /*"data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-80 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 duration-600 ease-in-out data-[state=closed]:animate-out data-[state=open]:animate-in"*/
          )}
        />
      )}
    </div>
  );
};
